import { createClientLogger } from './clientLogger';
import { initFaro } from './initFaro';
import { APP_VERSION, APP_NAME } from './appVersion';
import { correlationHeaders, getSessionCorrelationId, nextRequestIds } from './correlation';

export { APP_VERSION, APP_NAME };

export const clientLog = createClientLogger({
  service: 'pegasus-ui',
  version: APP_VERSION,
});

export function initObservability() {
  initFaro();
  clientLog.init();
}

export {
  initFaro,
  correlationHeaders,
  getSessionCorrelationId,
  nextRequestIds,
  createClientLogger,
};
